/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { IdentityService } from './services/identity.service';
import { GrantService } from './services/grant.service';
import { UserRoleService } from './services/user-role.service';
import { StatusWorkflowService } from './services/status-workflow.service';
import { IntegrationEventsService } from './services/integration-events.service';
import { RegistryService } from './services/registry.service';
import { CountryService } from './services/country.service';
import { RegistryOfficesService } from './services/registry-offices.service';
import { ProductCategoryService } from './services/product-category.service';
import { ProductService } from './services/product.service';
import { VatService } from './services/vat.service';
import { AddressBookService } from './services/address-book.service';
import { MediaService } from './services/media.service';
import { OrderService } from './services/order.service';
import { WarehouseService } from './services/warehouse.service';
import { DdtService } from './services/ddt.service';
import { CommonService } from './services/common.service';
import { AgreementsService } from './services/agreements.service';
import { ServicesService } from './services/services.service';
import { GeoService } from './services/geo.service';
import { GlsShipmentsService } from './services/gls-shipments.service';
import { BrtShipmentsService } from './services/brt-shipments.service';
import { SchedulazioniService } from './services/schedulazioni.service';
import { TicketService } from './services/ticket.service';
import { TicketStatusService } from './services/ticket-status.service';
import { ApiService } from './services/api.service';
import { DeliveryService } from './services/delivery.service';
import { AssetManagementService } from './services/asset-management.service';
import { SlaService } from './services/sla.service';
import { AllegatiService } from './services/allegati.service';
import { NxLicenseService } from './services/nx-license.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    IdentityService,
    GrantService,
    UserRoleService,
    StatusWorkflowService,
    IntegrationEventsService,
    RegistryService,
    CountryService,
    RegistryOfficesService,
    ProductCategoryService,
    ProductService,
    VatService,
    AddressBookService,
    MediaService,
    OrderService,
    WarehouseService,
    DdtService,
    CommonService,
    AgreementsService,
    ServicesService,
    GeoService,
    GlsShipmentsService,
    BrtShipmentsService,
    SchedulazioniService,
    TicketService,
    TicketStatusService,
    ApiService,
    DeliveryService,
    AssetManagementService,
    SlaService,
    AllegatiService,
    NxLicenseService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
